import SolidHeartIcon from 'LuxKit/Icons/solid/SolidHeartIcon'
import IconInCircle from 'tripPlanner/components/Icons/IconInCircle'

interface Props {
  size?: number
  iconSize?: number
}

function PinHeart({ size = 8, iconSize = 14 }: Props) {
  return (
    <IconInCircle
      icon={SolidHeartIcon}
      iconColour="dark-contrast"
      iconSize={size}
      size={iconSize}
      circleColour="favourite"
    />
  )
}

export default PinHeart
